import {
	getCulture,
	getMarketId,
	getPageId
} from "./globalData";
import Events from 'shared/settings/events';

export function initGlobalAxiosSettings(axiosGlobalOrInstance) {
	axiosGlobalOrInstance.interceptors.request.use((config) => {
		// in mocked axios headers is empty
		if (config.headers) {
			config.headers['App-Language'] = getCulture();
			config.headers['App-Market-Id'] = getMarketId();
			config.headers['App-Page-Id'] = getPageId();
		}

		return config;
	});
	axiosGlobalOrInstance.interceptors.response.use((response) => {
		// trigger a DOM event whenever an axios request completes. On websites where we want to show the modal
		// before a user gets logged out, that DOM event allows us to reset the timer to match that the session
		// has been renewed by doing the API request
		const customEvent = new CustomEvent(Events.API_CALL_COMPLETE, {});
		document.dispatchEvent(customEvent);

		return response;
	})
}
